/**
 * MEB licence 登入請求（POST {getLicenseBaseUrl}/api/v1/admin/login）
 */
export interface MebLoginRequest {
	username: string
	password: string
}

/**
 * MEB licence 登入原始回傳
 *
 * enableOTP：1 代表此帳號已綁定 2FA secret，0（或缺漏）代表尚未綁定；決定 /2fa 頁面顯示 QRCode 綁定畫面還是純輸碼畫面
 * allowPass2FA：true 代表來源 IP 在白名單內，token 已是 tfa=true 的正式 token，可略過 2FA
 * - 出處：service-license-api 的 `origin/feature#1422-ha` 分支 `app/Services/v1/admin/AdminUserService.php:85-87`、`:105`
 * errno：業務碼；err=true 且 errno=1036 代表 IP 在白名單但尚未綁定 2FA，data.token 仍是暫時 token，需走綁定流程
 * - 出處：service-license-api 的 `origin/feature#1422-ha` 分支 `AdminUserService.php:89-95`
 */
export interface MebLoginRawResponse {
	err: boolean
	errno: number
	msg: string
	data: {
		token: string
		enableOTP?: number
		allowPass2FA?: boolean
	}
}

/**
 * MEB licence 登入解析後結果（token、是否需要 2FA 綁定、是否可略過 2FA）
 */
export interface MebLoginResult {
	token: string
	needsTwoFaSetup: boolean
	allowPass2FA: boolean
}
